<template>
  <div class="content-center-wrapper">
    <div class="white-container d-flex align-items-center justify-content-center">
      <div class="col-md-8 text-center">
        <div class="col-12 mb-4">
          <img src="@/assets/img/logos/qqq.png" height="auto" width="150" />
        </div>
        <form>
          <div class="col-10 mx-auto mb-4">
            <p class="mb-3">Enter the trial Key if trail or the license key & activate it.</p>
            <div class="input-material">
              <input
                v-model="auth_key"
                type="text"
                id="Enter_Activation_Key"
                name="Enter_Activation_Key"
                v-validate="'required'"
              />
              <!-- |alpha_num|min:24|max:24 -->
              <label>Enter Activation Key</label>
            </div>
            <p
              v-if="submitted && errors.has('Enter_Activation_Key')"
              class="error_message"
            >{{ errors.first(`${'Enter_Activation_Key'}`)}}</p>
            <!-- <p v-if="auth_key == null && submitted" class="error_msg">Please Enter a valid key</p> -->
            <!-- <div class="my-2">OR</div> -->

            <!-- <label for="file-selector" class="file-selector w-100">
            <span>Browse Key</span>
            <input type="file" id="file-selector" class="d-none" />
            </label>-->

            <router-link class="btn-blue-lg w-100 mt-4" @click.native="onSubmit()" to>Activate</router-link>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import SetupService from "@/services/SetupService";

export default {
  data() {
    return {
      auth_key: null,
      submitted: false,
      // token: null
    };
  },
  mounted() {
    this.auth_key = this.$route.query.token;
  },
  watch: {
    auth_key: function (newVal, oldVal) {
      this.auth_key = newVal;
    },
  },
  methods: {
    onSubmit: function () {
      this.submitted = true;
      this.$validator.validate().then((valid) => {
        console.log("valid :", valid);
        if (valid) {
          //  this.submitted = true;
          if (this.auth_key !== null) {
            let payload = {
              auth_key: this.auth_key,
            };
            SetupService.VerfiyAuthKey(payload)
              .then((response) => {
                const { data } = response;
                if (data && data.status) {
                  this.$router.replace({
                    path: "select-installation-type",
                  });
                  window.localStorage.setItem("AUTH_KEY", this.auth_key);
                } else {
                  this.$toasted.show(data.message);
                }
              })
              .catch((error) => {
                this.$toasted.show(error);
              });
          }
        }
      });
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/Installation/enterTrialKey.vue